import type { SportUnit, Completion } from "@/lib/schemas";

// PL etykieta jednostki sportu. "powt." dla powtórzeń (pompki, brzuszki),
// "min" dla czasu (bieg, rower, piłka, koszykówka).
export function sportUnitLabel(unit: SportUnit | undefined): string {
  return unit === "minutes" ? "min" : "powt.";
}

// Rekord życiowy dla konkretnego sport chore: max sportDone z approved
// completions tego chore. null gdy brak żadnego approved completion.
// Liczone lokalnie z istniejącej listy completions — bez nowego pola w bazie.
export function sportRecord(
  completions: Completion[],
  choreId: string,
): number | null {
  let max: number | null = null;
  for (const c of completions) {
    if (c.choreId !== choreId) continue;
    if (c.status !== "approved") continue;
    if (c.kind !== "sport") continue;
    if (typeof c.sportDone !== "number") continue;
    if (max === null || c.sportDone > max) max = c.sportDone;
  }
  return max;
}
